export default "__VITE_ASSET__4a9886a3__"